module.exports = __webpack_public_path__ + "img/xmsb12.6cd28512.png";